import styled from "styled-components";
import { Divider } from "antd";
import AntButton from "uiKits/Button";
import { media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  background: #fafafb;
  padding: 50px 35px;
  width: 100%;
  box-sizing: border-box;

  ${media.downTablet`
    padding: 32px 20px;
  `}

  ${media.downMobile`
    padding: 24px 16px;
  `}
`;

export const MainHeading = styled.h3`
  margin: 0px;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const BalanceWrapper = styled.div`
  margin: 50px 0px;

  ${media.downTablet`
    margin: 32px 0;
  `}
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 12px;
`;

export const ItemTitle = styled.h4`
  margin: 0px;
  color: #575757;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

export const TotalItemTitle = styled.h4`
  margin: 0px;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ItemPrice = styled.p`
  margin: 0px;
  color: #000;
  text-align: right;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

export const StyledDivider = styled(Divider)`
  background: #b0b0b0;
`;

export const ButtonWrapper = styled.div`
  margin-top: 30px;
`;

export const StyledButton = styled(AntButton)`
  min-height: 44px;
  height: 50px;
  width: 50%;

  ${media.downTablet`
    width: 100%;
  `}
`;

export const MarketplaceRow = styled.div`
  margin: 18px 0 8px;
`;

export const MarketplaceLabel = styled.p`
  margin: 0 0 8px;
  color: #575757;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
`;

export const MarketplaceSelect = styled.select`
  width: 100%;
  min-height: 44px;
  height: 42px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 10px;
  font-family: Inter;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
`;
